var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_isReady)?_c('div',[(_vm.calculation)?_c('solution-sheet',{attrs:{"calculation":_vm.calculation}}):_c('p',[_vm._v("Cálculo não encontrado")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }